import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidatorsService {
  constructor() {}

  getErrorMail(formGroup: FormGroup, controlName: string) {
    return formGroup.controls[controlName].hasError('required')
      ? 'E-Mail-Adresse ist erforderlich'
      : formGroup.controls[controlName].hasError('pattern')
      ? 'Die E-Mail-Adresse ist nicht gültig'
      : '';
  }

  getErrorPassword(formGroup: FormGroup, controlName: string) {
    return formGroup.controls[controlName].hasError('required')
      ? 'Passwort ist erforderlich'
      : formGroup.controls[controlName].hasError('pattern')
      ? 'Muss mindestens 6 Zeichen (davon mind. 1 Kleinbuchstaben, 1 Großbuchstaben und 1 Zahl) enthalten'
      : '';
  }

  atLeastOneRequired(field1: string, field2: string) {
    return (formGroup: FormGroup) => {
      const firstField = formGroup.get(field1);
      const secondField = formGroup.get(field2);
      if (firstField && secondField && (firstField.value || secondField.value)) {
        return null; // Kein Fehler, wenn mindestens eines der Felder gefüllt ist
      } else {
        return { atLeastOneRequired: true }; // Fehlerobjekt zurückgeben, wenn beide Felder leer sind
      }
    };
  }

  mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  getErrorConfirmField(formGroup: FormGroup, controlName: string) {
    return formGroup.controls[controlName].hasError('required')
      ? 'Wiederholung der E-Mail-Adresse ist erforderlich'
      : formGroup.controls[controlName].hasError('mustMatch')
      ? 'E-Mail-Adressen stimmen nicht überein'
      : '';
  }

  checkboxRequiredValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return control.value === true ? null : { required: true };
    };
  }

  isPdfValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return { required: true };
      }

      const file: File = control.value;
      if (file?.type !== 'application/pdf') {
        return { mustBePdf: true };
      }
      return null;
    };
  }
}
